import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/lazy";
import SwiperCore, {
  Lazy, Pagination, Navigation
} from 'swiper';

SwiperCore.use([Lazy, Pagination, Navigation]);
import "./Carousel.css";

    const Carousel= (props)=>{
    let params = {
      allowSlideNext:true,
      allowSlidePrev:true,

        dir: "ltr",
        modules: [ Navigation,Lazy],//, Lazy
        preloadImages: false,
        observer: true,
        lazy: true,
        loop: true,
        grabCursor: true,
        keyboard: {
          "enabled": true
        },
        navigation: true,
        style: { '--swiper-navigation-color': '#fff', '--swiper-pagination-color': '#B69863' },
        slidesPerView: 1.2,
        spaceBetween: 10,
        //initialSlide: 4,
        breakpoints: {
          312: {
            slidesPerView: 1.2,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 50,
          }
          
        },
        speed:600
         };
    const [activetionControll,setActivetionControll] = useState([]);
    const [visibleElements,setVisibleElements] = useState(3);
    const [isMobile, setIsMobile] = useState(true);
    useEffect(()=>{
    
      if(window.innerWidth > 768){
        setIsMobile(false);
      
      }
        if(props.items.length>0){

            let tempArray = new Array(props.items.length).fill(true);
            tempArray.fill(false,visibleElements);
            setActivetionControll(tempArray);
        }
    },[props.items]);

    const ChangeActivtion=(e)=>{
        if(e.target.className.indexOf('prev')>-1){
            //take prev
            let tempArray =[...activetionControll];
            const firstFalseIdx = tempArray.indexOf(false);

            tempArray[firstFalseIdx]=true;
            tempArray[firstFalseIdx+visibleElements]=false;
            setActivetionControll(tempArray);
            
        }
        else{
          
            let tempArray =[...activetionControll];
            const firstFalseIdx = tempArray.indexOf(false);

            tempArray[firstFalseIdx]=true;
            tempArray[firstFalseIdx-visibleElements]=false;
            setActivetionControll(tempArray);
            //take next
        }
    }

    return (
    
        <div >
          
         <Swiper {...params} initialSlide="2">
          {props.items.map(
            (item, idx) =>
    
              (
                <SwiperSlide key={`slide_${idx}`}>
                   <a href={!!item.MashanTopDesktopImage ? item.MashanTopDesktopImage.Hyperlink: '#'} 
                      alt={!!item.MashanTopDesktopImage ?item.MashanTopDesktopImage.AlternateText : ''} >
                    <img
                      alt=''
                      key={item.MashanTopDesktopImage.ImageUrl}
                      className="swiper-lazy img-fluid "

                     data-src={item.MashanTopDesktopImage.ImageUrl+(isMobile ? '?RenditionID=6': '?RenditionID=5')}
                     src={item.MashanTopDesktopImage.ImageUrl+(isMobile ? '?RenditionID=6': '?RenditionID=5')}
                     loading="lazy"

                    />
                    <div className='img-carousel-title'>{item.ContainerTitle}</div>
                   </a> 
                </SwiperSlide>
              )
          )}
        </Swiper> 
       </div>
        
    )
}

export default Carousel;